import { render, staticRenderFns } from "./RatingStatsBlock.vue?vue&type=template&id=413f2fee&scoped=true&"
import script from "./RatingStatsBlock.vue?vue&type=script&lang=js&"
export * from "./RatingStatsBlock.vue?vue&type=script&lang=js&"
import style0 from "./RatingStatsBlock.vue?vue&type=style&index=0&id=413f2fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f2fee",
  null
  
)

export default component.exports